<template>
  <div class="wrapper">
    <div class="searchBar">
      <el-form
        ref="form"
        size="small"
        :inline="true"
        :model="searchCondition"
        label-width="80px"
      >
        <el-form-item label="姓名">
          <el-input v-model="searchCondition.userName"></el-input>
        </el-form-item>
        <el-form-item label="身份证">
          <el-input v-model="searchCondition.idCard"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchCondition.mobile"></el-input>
        </el-form-item>
        <el-form-item label="采集码">
          <el-input v-model="searchCondition.cjCode"></el-input>
        </el-form-item>
        <el-form-item label="学历层次">
          <el-select v-model="searchCondition.educationalLevel">
            <el-option label="所有学历" value=""></el-option>
            <el-option label="开放本科" value="本科"></el-option>
            <el-option label="开放专科" value="专科"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学习中心">
          <el-select v-model="searchCondition.schoolName">
            <el-option label="所有学习中心" value=""></el-option>
            <el-option label="重庆学习中心" value="重庆"></el-option>
            <el-option label="上海学习中心" value="上海"></el-option>
            <el-option label="山西学习中心" value="山西"></el-option>
            <el-option label="江苏学习中心" value="江苏"></el-option>
            <el-option label="青岛学习中心" value="青岛"></el-option>
            <el-option label="广西学习中心" value="广西"></el-option>
            <el-option label="福建学习中心" value="福建"></el-option>
            <el-option label="天津学习中心" value="天津"></el-option>
            <el-option label="河北学习中心" value="河北"></el-option>
            <el-option label="山东学习中心" value="山东"></el-option>
            <el-option label="新疆学习中心" value="新疆"></el-option>
            <el-option label="云南学习中心" value="云南"></el-option>
            <el-option label="广东学习中心" value="广东"></el-option>
            <el-option label="北京学习中心" value="北京"></el-option>
            <el-option label="贵州学习中心" value="贵州"></el-option>
            <el-option label="南通学习中心" value="南通"></el-option>
            <el-option label="安徽审计职业学院学习中心" value="安徽审计职业学院"></el-option>
            <el-option label="西安立讯科技技师学院学习中心" value="西安立讯科技技师学院"></el-option>
            <el-option label="内蒙古建筑职业技术学院学习中心" value="内蒙古建筑职业技术学院"></el-option>
            <el-option label="辽宁生态工程职业学院学习中心" value="辽宁生态工程职业学院"></el-option>
            <el-option label="唐山科技中等专业学校学习中心" value="唐山科技中等专业学校"></el-option>
            <el-option label="滁州职业技术学院学习中心" value="滁州职业技术学院"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学号">
          <el-input v-model="searchCondition.schoolNo"></el-input>
        </el-form-item>
              筛选时间：<el-date-picker
                  size="mini"
                  v-model="timeRange"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
      </el-form>
      <el-button type="primary" size="small" @click="getData()">查询</el-button>
      <el-button type="primary" size="small"  @click="ifBatch =true" :disabled="searchCondition.photoStatus!=2">批量审核</el-button>
      <el-button
        size="small"
        @click="Object.assign(searchConditon, $options.data().searchConditon)"
        >重置</el-button
      >
<!--      <el-button size="small" @click="downloadZip">下载采集资料压缩包-->
<!--      </el-button>-->
      &nbsp;
        <el-dropdown @command="downloadZip">
            <el-button  size="small" plain>

                下载采集码zip<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">

                <el-dropdown-item :command="1" >下载筛选条件下全部</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        &nbsp;
        <el-dropdown @command="downloadImg">
        <el-button type="primary" size="small" plain>
          下载学号zip<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="1"
          >下载全部（已通过）</el-dropdown-item
          >
          <el-dropdown-item :command="2" >下载筛选条件下全部</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
    <div class="contentContainer">
      <el-tabs v-model="searchCondition.photoStatus" @tab-click="getData">
        <!-- <el-tab-pane label="所有" :name="-1"></el-tab-pane> -->
        <el-tab-pane label="待审核" name="2"></el-tab-pane>
        <el-tab-pane label="已拒绝" name="0"></el-tab-pane>
        <el-tab-pane label="已通过" name="1"></el-tab-pane>
      </el-tabs>
      <div class="contentBar">
        <el-checkbox  v-show="searchCondition.photoStatus==2 && dataList.length>0"  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div
          class="contentCell"
          v-for="item in dataList"
          :key="'content' + item.id"
        >

          <div class="detailBar">
            <el-checkbox style="padding:5px"  v-show="searchCondition.photoStatus==2"  v-model="item.choose" @change="handleCheckedCitiesChange(item.id)" > </el-checkbox>
            学号:{{ item.schoolNo }} &emsp;{{ item.userName }}
          </div>
          <div class="imgBar">
            <el-image :src="item.avatar" fit="contain"></el-image>
          </div>
          <div class="actBar">
            <el-button type="primary" size="mini" :disabled="searchCondition.photoStatus!=2" @click="audit(1, item)">
              通过
            </el-button>
            <el-button type="danger" size="mini" :disabled="searchCondition.photoStatus!=2" @click="audit(0, item)">
              拒绝
            </el-button>
            <el-button size="mini" @click="showDetail(item)"> 详情 </el-button>
          </div>
        </div>
      </div>
      <el-pagination
        small
        layout="prev, pager, next"
        :current-page.sync="searchCondition.pageNumber"
        :page-size.sync="searchCondition.pageSize"
        :total="searchCondition.total"
        @current-change="getData()"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="详情"
      :visible.sync="detailData.ifShow"
      width="60%"
      :append-to-body="true"
    >
      <div class="twoSideBox">
        <div class="flex1">
          <div class="twoSideBox">
            <div class="key">采集码：</div>
            <div class="value">
              <el-input
                  size="small"
                  v-model="detailData.cjCode"
                  disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">姓名：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.userName"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">手机号：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.mobile"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">身份证：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.idCard"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">性别：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.sex"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">学历层次：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.educationalLevel"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">院校类别：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.institutionType"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">学号：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.schoolNo"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="twoSideBox">
            <div class="key">学习中心：</div>
            <div class="value">
              <el-input
                size="small"
                v-model="detailData.schoolName"
                disabled
              ></el-input>
            </div>
          </div>
        </div>
        <div class="flex1">
          <div>
            <el-image :src="detailData.avatar" fit="contain"></el-image>
          </div>
          <br />
          <div>
            <el-button size="small" type="primary" @click="audit(1, detailData)"
              >通过审核</el-button
            >
            <el-button size="small" type="danger" @click="audit(0, detailData)"
              >拒绝审核</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>


    <el-dialog  title="批量操作" :visible.sync="ifBatch" append-to-body @close="clearData()">
      <div style="color: red"> 提示：正在操作{{this.checkedList.length}}条数据，请谨慎操作！</div>
      <el-form :model="batchData">
        <el-form-item label="审核结果：" >
          <el-radio-group v-model="batchData.batchStatus">
            <el-radio label="1">通过</el-radio>
            <el-radio label="0">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见：" >
          <textarea v-model="batchData.reviewRemark" name="summary" rows="3" cols="60"></textarea>
        </el-form-item>
      </el-form>
<!--      <div class="inputDiv">-->
<!--        审核结果：-->
<!--        <input type="radio" name="radios" v-model="batchStatus" value="1" checked><label>通过</label>&nbsp&nbsp&nbsp&nbsp&nbsp-->
<!--        <input type="radio" name="radios" v-model="batchStatus" value="2"><label>拒绝</label>-->
<!--      </div>-->
<!--      <div>-->
<!--        <span style="vertical-align:top">审核意见：</span><textarea v-model="remarks" name="summary" rows="3" cols="60"></textarea></div>-->


      <span slot="footer" class="dialog-footer">
        <el-button @click="ifBatch = false;clearData()">取 消</el-button>
        <el-button type="primary" @click="batchReview(batchData.batchStatus,batchData.reviewRemark)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPhotoReviewList,
  photoReview,
  downloadPhotoCheckZip,
  downloadIamgesByxh,
} from "@/api/examination.js";
export default {
  data() {
    return {
      batchData:{
        reviewRemark:"",
        batchStatus:"0",
      },
      checkedList:[],
      checkAll:false,
      ifBatch:false,
      searchCondition: {
          pageNumber: 1,
        pageSize: 10,
        photoStatus: "2", //
        userName: "",
        idCard: "",
        mobile: "",
        schoolName: "",
        schoolNo: "",
        cjCode:"",
        educationalLevel: "",
        total: 0,
      },
        timeRange:[],
      dataList: [],
      detailData: {
        ifShow: false,
        authorityComparisionScore: 37,
        avatar: "",
        createTime: "",
        deleted: 0,
        educationalLevel: "",
        groupId: "",
        groupName: "",
        id: "",
        idCard: "",
        importUser: "",
        institutionType: "",
        mobile: "",
        photoStatus: 0,
        photoStatusText: "",
        profession: "",
        reviewRemark: "",
        schoolName: "",
        schoolNo: "",
        sex: "",
        updateTime: "",
        userName: "",
        cjCode:"",
      },
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    clearData(){
      Object.assign(this.batchData, this.$options.data().batchData)
    },
    showDetail(item) {
      Object.assign(this.detailData, item);
      this.detailData.ifShow = true;
    },
    getData() {
      getPhotoReviewList(this.searchCondition).then((data) => {
        console.log(data);
        this.dataList = data.data.rows;
        this.searchCondition.total = data.data.total;
      });
    },
    audit(status, item) {
      this.$prompt(`请输入${status ? "通过" : "拒绝"}原因`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then((data) => {
        photoReview({ batchPhotoStatus: status, ids: [item.id] , reviewRemark: data.value }).then(
          (data) => {
            this.$message.success("操作成功");
            this.detailData.ifShow = false;
            this.getData();
          }
        );
      });
    },
    downloadZip() {
      downloadPhotoCheckZip( this.searchCondition )
        .then((res) => {
          const blob = new Blob([res], { type: "application/zip" }); // new一个二进制对象
          const url = window.URL.createObjectURL(blob); // 转化为url
          const link = document.createElement("a"); // 创建个a标签
          link.href = url;
          link.download = "国开审核资料压缩包（采集码）"; // 重命名
          link.click();
          URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    downloadImg(val) {
     let that = this;
      if (val==1){
        downloadIamgesByxh(   {photoStatus : 1})
            .then((res) => {
              const blob = new Blob([res], { type: "application/zip" }); // new一个二进制对象
              const url = window.URL.createObjectURL(blob); // 转化为url
              const link = document.createElement("a"); // 创建个a标签
              link.href = url;
              link.download = "国开审核资料压缩包（学号）"; // 重命名
              link.click();
              URL.revokeObjectURL(url);
            })
            .catch((err) => {
              console.error(err);
            });
      }else {
        downloadIamgesByxh(that.searchCondition)
            .then((res) => {
              const blob = new Blob([res], {type: "application/zip"}); // new一个二进制对象
              const url = window.URL.createObjectURL(blob); // 转化为url
              const link = document.createElement("a"); // 创建个a标签
              link.href = url;
              link.download = "国开审核资料压缩包（学号）"; // 重命名
              link.click();
              URL.revokeObjectURL(url);
            })
            .catch((err) => {
              console.error(err);
            });
      }
    },


    batchReview(status,remark){
      let checkedAll = [];
                       this.dataList.forEach(item => {
                             if(item.choose == true){
                                   checkedAll.push(item.id)   //确认的时候取状态为true的值，并把要用的字段取出来
                               }
                        })
                       // var checkedAll = [...new Set(this.checkedCities)] //数组去重
                       console.log("选中的：",checkedAll)
                       this.classLoading = true;
      this.$confirm(`正在操作${checkedAll.length}条数据${status ? "通过" : "拒绝"}审核`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then((data) => {
        console.log("来了哦",status,remark)
        photoReview({batchPhotoStatus: status, ids: checkedAll ,reviewRemark: remark }).then(
            (data) => {
              this.$message.success("操作成功");
              this.detailData.ifShow = false;
              this.getData();
            }
        );
        //关闭弹窗
        this.ifBatch=false;
        this.clearData();
        this.getData();
      });


    },


    handleCheckAllChange(val) {
          if (this.checkAll) {
                this.dataList.forEach(item => {
                       item.choose = true   //只改变数据的状态
                    })

            let checkedAll = [];
            this.dataList.forEach(item => {
              if(item.choose == true){
                checkedAll.push(item.id)   //确认的时候取状态为true的值，并把要用的字段取出来
              }
            })
            // var checkedAll = [...new Set(this.checkedCities)] //数组去重
            console.log("aaa",checkedAll)
         this.checkedList =checkedAll;

              } else {
               this.dataList.forEach(item => {
                     item.choose = false
                       })
                   }
             },
     handleCheckedCitiesChange(val) {
      console.log("单个",val);
     // if (this.checkedList.length == this.dataList.length) {
       if (val.length == this.dataList.length) {
       this.checkAll = true
         } else {
           this.checkAll = false
        }
       let checkedAll = [];
       this.dataList.forEach(item => {
         if(item.choose == true){
           checkedAll.push(item.id)   //确认的时候取状态为true的值，并把要用的字段取出来
         }
       })
       // var checkedAll = [...new Set(this.checkedCities)] //数组去重
       console.log("bbb",checkedAll)
       this.checkedList =checkedAll;
   },



  },

    watch:{
        timeRange(val) {
            console.log("时间变了", val);
            if(val==null){
                this.searchCondition.startTime="";
                    this.searchCondition.endTime=""
            }else {
                [this.searchCondition.startTime, this.searchCondition.endTime] = val;
            }
            console.log(this.searchCondition.startTime, this.searchCondition.endTime,this.timeRange);
        },

    }
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    background: #fff;
    margin: 20px;
    padding: 20px;
  }
  .contentContainer {
    background: #fff;
    margin: 20px;
    padding: 20px;

    .contentBar {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .contentCell {
        width: 25%;
        padding: 30px;
        .detailBar {
        }
        .imgBar {
          .el-image {
            width: 60%;
            height: 200px;
            display: block;
            margin: auto;
          }
        }
        .actBar {
          display: flex;
          justify-content: space-evenly;
        }
      }
    }
  }
}
.twoSideBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  margin: 20px;
  .flex1 {
    flex: 1;
    margin: 30px;
    // padding: 50px;
  }
}

.inputDiv{
  white-space: nowrap;
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
